import { FC } from "react";
import { Box, Flex, Select, Table, Text } from "@radix-ui/themes";
import { Submission } from "@/models/database/submissions/Submission.model";
import SubmissionsItem from "./submissions.item";

interface SubmissionsUIProps {
  data: Submission[];
  status: "approved" | "rejected" | "pending";
  setStatus: (status: "approved" | "rejected" | "pending") => void;
}

const SubmissionsUI: FC<SubmissionsUIProps> = ({
  data,
  status,
  setStatus,
}): JSX.Element => {
  return (
    <Flex direction="column" gap="4">
      <Flex justify="start">
        <Select.Root
          value={status}
          onValueChange={(value) => {
            setStatus(value as "approved" | "rejected" | "pending");
          }}
        >
          <Select.Trigger />
          <Select.Content>
            <Select.Item value="approved">Approved</Select.Item>
            <Select.Item value="pending">Pending</Select.Item>
            <Select.Item value="rejected">Rejected</Select.Item>
          </Select.Content>
        </Select.Root>
      </Flex>

      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Date & Time</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Challenge</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Time / Points</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Screenshot</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>User</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Status</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {data &&
            data.map((submission) => (
              <SubmissionsItem data={submission} key={submission.id} />
            ))}
        </Table.Body>
      </Table.Root>

      {data && data.length === 0 && (
        <Box>
          <Text>There are no {status} submissions available.</Text>
        </Box>
      )}
    </Flex>
  );
};

export default SubmissionsUI;
